<div class="register-container">
    <div class="left-panel d-none d-md-block">
        <div class="overlay">
            <h3 class="font-weight-bolder mb-3">Forgot Password</h3>
            <img src="assets/img/mykadainew.png" class="img-fluid register-logo" [routerLink]="['/']" type="button">
        </div>
    </div>
    <div class="right-panel">
        <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
            <div class="text-center d-block">
                <img src="assets/img/icons/forgot-password.png" class="img-fluid" style="height: 100px"
                     [routerLink]="['/']" type="button">
            </div>
            <!--  <div class="text-center">
                  <img src="assets/img/icons/forgot-password.png" class="img-fluid" style="height: 100px"
                       [routerLink]="['/']" type="button">
              </div>
              <h3 class="font-weight-bolder mb-3 text-center mt-3">Forget Password</h3>-->
            <p class="mt-2 mb-2 text-muted">A verification OTP will be sent to your Email.</p>

            <div class="form-floating mb-3">
                <input
                        type="email"
                        class="form-control"
                        id="emailId"
                        placeholder="Registered Email"
                        formControlName="emailId"
                        [ngClass]="{
                 'is-invalid': forgotPasswordForm.get('emailId')?.invalid && forgotPasswordForm.get('emailId')?.touched,
                 'is-valid': forgotPasswordForm.get('emailId')?.valid && forgotPasswordForm.get('emailId')?.touched
               }"
                />
                <label for="emailId">Registered Email Address</label>
                <span *ngIf="forgetPasswordError.emailId"
                      class="error-text">{{ forgetPasswordError.emailId }}</span>
            </div>

            <div *ngIf="isOTPSent">
                <div class="form-floating mb-3">
                    <input
                            type="email"
                            class="form-control"
                            id="phoneNumber"
                            placeholder="Registered Phone Number"
                            formControlName="phoneNumber"
                            [ngClass]="{
                 'is-invalid': forgotPasswordForm.get('phoneNumber')?.invalid && forgotPasswordForm.get('phoneNumber')?.touched,
                 'is-valid': forgotPasswordForm.get('phoneNumber')?.valid && forgotPasswordForm.get('phoneNumber')?.touched
               }"
                    />
                    <label for="emailId">Registered Phone Number</label>
                    <span *ngIf="forgetPasswordError.phoneNumber"
                          class="error-text">{{ forgetPasswordError.phoneNumber }}</span>
                </div>

                <div class="form-floating mb-3">
                    <input
                            type="text"
                            class="form-control"
                            id="verificationOtp"
                            placeholder="Enter your OTP"
                            formControlName="verificationOtp"
                            maxlength="4"
                            minlength="4"
                            (keypress)="OnlyNumbers($event)"
                            [ngClass]="{
                 'is-invalid': forgotPasswordForm.get('verificationOtp')?.invalid && forgotPasswordForm.get('verificationOtp')?.touched,
                 'is-valid': forgotPasswordForm.get('verificationOtp')?.valid && forgotPasswordForm.get('verificationOtp')?.touched
               }"
                    />
                    <label for="emailId">OTP</label>
                    <span *ngIf="forgetPasswordError.verificationOtp"
                          class="error-text">{{ forgetPasswordError.verificationOtp }}</span>
                </div>


                <div class="form-floating mb-3">
                    <input
                            [type]="isPasswordVisible ? 'text' : 'password'"
                            class="form-control"
                            id="password"
                            placeholder="New Password"
                            formControlName="password"
                            [ngClass]="{
                 'is-invalid': forgotPasswordForm.get('password')?.invalid && forgotPasswordForm.get('password')?.touched,
                 'is-valid': forgotPasswordForm.get('password')?.valid && forgotPasswordForm.get('password')?.touched
               }"
                    />
                    <label for="password">New Password</label>
                    <i class="toggle-password fa"
                       [ngClass]="{'fa-eye': !isPasswordVisible, 'fa-eye-slash': isPasswordVisible}"
                       style="cursor:pointer;" (click)="togglePasswordVisibility()"></i>
                </div>
                <span *ngIf="forgetPasswordError.password"
                      class="error-text">{{ forgetPasswordError.password }}</span>

                <div class="form-floating mb-3 position-relative">
                    <input
                            [type]="isConfirmPasswordVisible ? 'text' : 'password'"
                            class="form-control"
                            id="confirmPassword"
                            placeholder="Confirm New Password"
                            formControlName="confirmPassword"
                            [ngClass]="{
                 'is-invalid': forgotPasswordForm.get('confirmPassword')?.invalid && forgotPasswordForm.get('confirmPassword')?.touched
               }"
                    />
                    <label for="password">Confirm New Password</label>
                    <i class="toggle-password fa"
                       [ngClass]="{'fa-eye': !isConfirmPasswordVisible, 'fa-eye-slash': isConfirmPasswordVisible}"
                       style="cursor:pointer;" (click)="toggleConfirmPasswordVisibility()"></i>
                </div>
                <span *ngIf="forgetPasswordError.confirmPassword"
                      class="error-text">{{ forgetPasswordError.confirmPassword }}</span>
            </div>

            <div class="d-flex justify-content-center flex-wrap gap-3 mt-3">
                <button class="btn btn-primary" type="submit" *ngIf="!isOTPSent">Send OTP</button>
                <!--<button class="btn btn-warning" type="submit" *ngIf="isOTPSent">Resend OTP</button>-->
                <button class="btn btn-success" type="submit" *ngIf="isOTPSent">Verify OTP</button>
            </div>
        </form>
    </div>
</div>